import { KEY_CONSTS } from './constants'

export const capitalize = word => {
  const firstSymbol = word.slice(0, 1)
  const restWordPart = word.slice(1)

  return firstSymbol.toUpperCase() + restWordPart
}

export const delay = delay => {
  return new Promise((resolve, reject) => {
    setTimeout(resolve, delay)
  })
}

const setEventListener = (element, typeEvent, handler, action) => {
  if (!handler || !element || !typeEvent) {
    return
  }

  const eventListenerSetter = `${action}EventListener`

  element[eventListenerSetter](typeEvent, handler)
}

export const _addEventListener = (element, typeEvent, handler) => {
  setEventListener(element, typeEvent, handler, 'add')
}

export const _removeEventListener = (element, typeEvent, handler) => {
  setEventListener(element, typeEvent, handler, 'remove')
}

export const viewportObserver = new IntersectionObserver((entries, _) => {
  entries.forEach(entry => {
    const isInViewport = entry.isIntersecting
    const isParentHidden = entry.target.closest('[aria-hidden="true"], .hidden')

    entry.target.classList.toggle(
      'is-in-viewport',
      isInViewport && !isParentHidden,
    )
  })
})

export const getFocusableTargets = () => {
  const targets = [
    'button',
    '[href]',
    '[data-focus-trap-target]',
    'a',
    '[tabindex]',
  ]

  return targets
    .map(
      target =>
        `${target}:not([tabindex="-1"]):not([data-color-swatches-hidden-count]:empty)`,
    )
    .join(',')
}

export const appendCustomElementToBody = customElement => {
  const customElementContainer = document.createElement('div')

  customElementContainer.classList.add('hidden')

  document.body.appendChild(customElementContainer)

  customElementContainer.appendChild(customElement)

  return customElementContainer
}

export const removeCustomElementFromBody = customElementContainer => {
  customElementContainer.remove()
}

export const isSafari = () => {
  // Chrome DevTools does not complain about navigator.vendor
  return /apple/i.test(navigator.vendor)
}

export const checkEnterKey = key =>
  key === KEY_CONSTS.ENTER_NUMBER_KEY || key === KEY_CONSTS.ENTER_STRING_KEY

export const checkSpaceKey = key =>
  key === KEY_CONSTS.SPACE_NUMBER_KEY || key === KEY_CONSTS.SPACE_STRING_KEY

export const checkEscKey = key =>
  key === KEY_CONSTS.ESCAPE_STRING_KEY || key === KEY_CONSTS.ESCAPE_NUMBER_KEY

export const checkRightKey = key =>
  key === KEY_CONSTS.ARROW_RIGHT_NUMBER_KEY ||
  key === KEY_CONSTS.ARROW_RIGHT_STRING_KEY

export const checkLeftKey = key =>
  key === KEY_CONSTS.ARROW_LEFT_NUMBER_KEY ||
  key === KEY_CONSTS.ARROW_LEFT_STRING_KEY

export const checkTabKey = key =>
  key === KEY_CONSTS.TAB_NUMBER_KEY || key === KEY_CONSTS.TAB_STRING_KEY

export const createPortal = (children, parent) => {
  let element = document.getElementById('Portal')

  element.appendChild(children)

  const target = parent && parent.appendChild ? parent : document.body

  target.appendChild(element)
}

export const getTransitionDuration = styles => {
  const transitionDuration = parseFloat(styles['transitionDuration']) * 1000

  const transitionDelay = parseFloat(styles['transitionDelay']) * 1000

  return transitionDuration + transitionDelay
}

export const isExternalLink = href => {
  return !href.match(/^\//) && !href.includes(window.location.host)
}

export const isCurrentPageLink = href => {
  return href === window.location.href
}

export const createPrefetchLink = href => {
  const link = document.createElement('link')
  link.setAttribute('rel', 'prefetch')
  link.setAttribute('href', href)
  document.head.appendChild(link)
}

export const createAutoplayVideosObserver = () => {
  const observedVideos = []

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.intersectionRatio <= 0) {
        entry.target.pause()
      } else {
        entry.target.play()
      }

      if (!observedVideos.find(el => el === entry.target)) {
        observedVideos.push(entry.target)
      }
    })
  })

  return { observedVideos, observer }
}

export const handleAutoplayVideos = ({ observedVideos, observer }) => {
  const videos = Array.from(document.querySelectorAll('video[autoplay]'))
    .filter(element => element.clientWidth > 0)
    .filter(element => !observedVideos.find(el => el === element))

  if (videos.length > 0) {
    videos.forEach(video => {
      observer.observe(video)
      video.play()
    })
  }
}
